import React from "react";

const LogoutModal = ({ settings, logOutOnClick, cancelLogout }) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 50,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: settings.modalOverlayColor.value,
      }}
    >
      <div
        style={{
          backgroundColor: settings.modalBackgroundColor.value,
          borderRadius: `${settings.modalBorderRadius.value}px`,
          padding: "1.5rem",
          boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          minWidth: "280px",
          maxWidth: "20rem",
          width: "100%",
          border: "1px solid #f3f4f6",
        }}
      >
        <div
          style={{
            fontSize: "1rem",
            fontWeight: "500",
            color: "#1f2937",
            marginBottom: "1.25rem",
            textAlign: "center",
          }}
        >
          Çıkış yapmak istediğinize emin misiniz?
        </div>
        <div
          style={{
            display: "flex",
            gap: "0.75rem",
            width: "100%",
            marginTop: "0.5rem",
          }}
        >
          <button
            style={{
              flex: 1,
              paddingTop: "0.5rem",
              paddingBottom: "0.5rem",
              borderRadius: "0.5rem",
              backgroundColor: settings.confirmButtonColor.value,
              color: settings.buttonTextColor.value,
              fontWeight: "600",
              transition: `background-color ${settings.animationDuration.value}ms`,
              boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
              border: "none",
              cursor: "pointer",
            }}
            onClick={logOutOnClick}
          >
            Evet
          </button>
          <button
            style={{
              flex: 1,
              paddingTop: "0.5rem",
              paddingBottom: "0.5rem",
              borderRadius: "0.5rem",
              backgroundColor: settings.cancelButtonColor.value,
              color: "#374151",
              fontWeight: "600",
              transition: `background-color ${settings.animationDuration.value}ms`,
              boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
              border: "1px solid #e5e7eb",
              cursor: "pointer",
            }}
            onClick={cancelLogout}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#e5e7eb")}
            onMouseLeave={(e) =>
              (e.target.style.backgroundColor =
                settings.cancelButtonColor.value)
            }
          >
            Hayır
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
